import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer(): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" id="footer">
      <div className="container">
        <div className="footer-grid">

          <div className="footer-brand">
            <Link to="/" className="footer-logo-link">
              <img src="/images/esgt-logo-no-background.png" alt="ESGTriage" className="footer-logo-img" />
            </Link>
            <p className="footer-desc">
              Sustainability intelligence for the enterprises that cannot afford to get it wrong.
            </p>
            <div className="footer-socials">
              <a
                href="https://linkedin.com/company/esgtriage"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                in
              </a>
              <a href="mailto:hello@esgtriage.com" className="social-link" aria-label="Email">
                &#64;
              </a>
            </div>
          </div>

          <div>
            <p className="footer-col-title">Platform</p>
            <ul className="footer-links">
              <li><Link to="/platform">Actula Overview</Link></li>
              <li><Link to="/platform#esg-data">ESG Data Collection</Link></li>
              <li><Link to="/platform#cbam">CBAM Compliance</Link></li>
              <li><Link to="/platform#pcf">Product Carbon Footprint</Link></li>
              <li><Link to="/platform#ccf">Corporate Carbon Footprint</Link></li>
              <li><Link to="/platform#procurement">Sustainable Procurement</Link></li>
            </ul>
          </div>

          <div>
            <p className="footer-col-title">Solutions</p>
            <ul className="footer-links">
              <li><Link to="/solutions/india">India &mdash; BRSR</Link></li>
              <li><Link to="/solutions/europe">Europe &mdash; CSRD</Link></li>
              <li><Link to="/solutions/europe">EU Taxonomy</Link></li>
              <li><Link to="/solutions/europe">CBAM</Link></li>
            </ul>
          </div>

          <div>
            <p className="footer-col-title">Company</p>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/resources">Resources</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="mailto:hello@esgtriage.com">hello@esgtriage.com</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-product-bar">
          <span className="footer-product-label">Powered by</span>
          <img src="/images/actula-logo.png" alt="Actula" className="footer-product-logo" />
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            &copy; {year} ESG Triage Technologies Private Limited &middot; CIN: U62012AP2026PTC125013
          </p>
          <div className="footer-compliance">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
